import { createAction } from 'redux-actions'

export const setSupportModalShown = createAction('SET_SUPPORT_MODAL_SHOWN')
export const setShowIdleModal = createAction('SET_SHOW_IDLE_MODAL')
export const showSuccessModal = createAction('SHOW_SUCCESS_MODAL')
export const hideSuccessModal = createAction('HIDE_SUCCESS_MODAL')
export const resetState = createAction('RESET_STATE')
